import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { useI18n } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { WhatsAppButton } from "@/components/WhatsApp";
import { ShoppingBag, PackageCheck, Rocket, PlayCircle, ArrowRight } from "lucide-react";

export default function HowItWorks() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const videos = [
    [ShoppingBag, t("hiw.v1"), t("hiw.v1d")],
    [PackageCheck, t("hiw.v2"), t("hiw.v2d")],
    [Rocket, t("hiw.v3"), t("hiw.v3d")],
  ];
  const faq = [
    [t("hiw.q1"), t("hiw.a1")],
    [t("hiw.q2"), t("hiw.a2")],
    [t("hiw.q3"), t("hiw.a3")],
  ];
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="mx-auto max-w-5xl px-4 sm:px-6 py-10">
        <h1 className="font-heading font-extrabold text-3xl tracking-tight" data-testid="hiw-title">{t("hiw.title")}</h1>
        <div className="mt-6 grid gap-4 md:grid-cols-3">
          {videos.map(([Icon, title, desc], i) => (
            <div key={i} className="border border-border bg-card p-5" data-testid={`hiw-video-${i + 1}`}>
              <div className="aspect-video bg-secondary flex flex-col items-center justify-center text-muted-foreground">
                <PlayCircle className="h-10 w-10" />
                <span className="mt-2 text-xs">{t("hiw.soon")}</span>
              </div>
              <div className="mt-3 flex items-center gap-2 font-heading font-bold"><Icon className="h-4 w-4 text-accent" /> {title}</div>
              <p className="mt-1 text-sm text-muted-foreground">{desc}</p>
            </div>
          ))}
        </div>
        <h2 className="mt-10 font-heading font-bold text-lg">{t("hiw.faqTitle")}</h2>
        <div className="mt-3 space-y-2">
          {faq.map(([q, a], i) => (
            <details key={i} className="border border-border bg-card p-4" data-testid={`hiw-faq-${i + 1}`}>
              <summary className="font-semibold cursor-pointer">{q}</summary>
              <p className="mt-2 text-sm text-muted-foreground">{a}</p>
            </details>
          ))}
        </div>
        <div className="mt-10 flex flex-wrap items-center gap-3">
          <Button data-testid="hiw-cta-shop" className="rounded-sm bg-accent text-white gap-1.5" onClick={() => navigate("/shopship")}>
            {t("hiw.ctaShop")} <ArrowRight className="h-4 w-4" />
          </Button>
          <Button data-testid="hiw-cta-goods" variant="outline" className="rounded-sm gap-1.5" onClick={() => navigate("/goods")}>
            {t("hiw.ctaGoods")} <ArrowRight className="h-4 w-4" />
          </Button>
          <WhatsAppButton />
        </div>
      </div>
    </div>
  );
}
